/** A media plan's status as one pill, the same on the list and the plan page. */

import React from 'react';
import { StatusPill } from '../../ui';
import type { MediaPlanStatus } from './types';
import { PLAN_STATUS_LABELS } from './types';
import { PLAN_STATUS_PILL } from './vocab';

const PlanStatusPill: React.FC<{ status: MediaPlanStatus; size?: 'sm' | 'md' }> = ({ status, size = 'sm' }) => {
  const look = PLAN_STATUS_PILL[status];
  return (
    <StatusPill variant={look.variant} appearance={look.appearance} size={size} style={look.faded ? { opacity: 0.6 } : undefined}>
      {PLAN_STATUS_LABELS[status]}
    </StatusPill>
  );
};

export default PlanStatusPill;
